// extracted by mini-css-extract-plugin
export default {"input-wrapper":"ManufacturerDropdown_input-wrapper__n4Qwd","menu":"ManufacturerDropdown_menu__yPNBV"};